import BucketApiRequest from "./BucketApiRequest";
import { GET_REASON_CODES } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetLoanProduct extends BucketApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return GET_REASON_CODES;
  };

  getBody = () => {
    return this.body;
  };
}
